/**
 * Calendar dates as `YYYY-MM-DD` keys in a timezone, shared by the chats list's row time and both
 * chat threads' day dividers (chat-thread-bottom-anchored-scroll D6). Yesterday is the calendar
 * date before today's key, never "now minus 24 hours", so the 23- and 25-hour days around a
 * daylight-saving change neither skip nor repeat a day.
 */

/** The calendar date of `at` in `timezone`, as `YYYY-MM-DD`. */
export function dateKey(at: Date | string, timezone: string): string {
  return new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: timezone })
    .format(typeof at === 'string' ? new Date(at) : at);
}

/** The calendar date before a `YYYY-MM-DD` key: date arithmetic, so a 23- or 25-hour day never skips or repeats one. */
export function previousDateKey(key: string): string {
  const [year, month, day] = key.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day - 1)).toISOString().slice(0, 10);
}
